import {
    add as _add,
    getList as _getList,
    update as _update,
    getOneById as _getOneById,
    deleteAll as _deleteAll,
    patchAsync as _patchAsync,
} from "../../api";
import { dateToString } from "utils/dateUtils";

const BASE_URL = "/coc/requests";
const DEFAULT_LIST_DATA = {
    filter: {},
    orderBy: "stampModificationDatetime",
    orderDirection: "desc",
    pageNumber: 0,
    pageSize: 10,
};

function normalizeRequestData(data) {
    const {
        stampCreationDatetime: stampCreationDatetimeInMillis,
        stampModificationDatetime: stampModificationDatetimeInMillis,
        dueDate: dueDateInMillis,
    } = data;

    const stampCreationDatetime = new Date(stampCreationDatetimeInMillis);
    const stampModificationDatetime = new Date(stampModificationDatetimeInMillis);
    const dueDate = new Date(dueDateInMillis);

    return {
        ...data,
        stampCreationDatetime,
        stampModificationDatetime,
        dueDate,
        stampCreationDatetimeString: dateToString(stampCreationDatetime),
        stampModificationDatetimeString: dateToString(stampModificationDatetime),
        dueDateString: dateToString(dueDate, false),
    };
}

function normalizeData(data) {
    return data.map(normalizeRequestData);
}

export function getList({ onSuccess, onInfo, onError, data = DEFAULT_LIST_DATA }) {
    _getList({ url: BASE_URL, data, onSuccess, onInfo, onError, normalizer: normalizeData });
}

export function add({ payload, onSuccess, onError }) {
    _add({ url: BASE_URL, data: payload, onSuccess, onError });
}

export function update({ payload, onSuccess, onError }) {
    _update({ url: `${BASE_URL}/${payload.id}`, data: payload, onSuccess, onError });
}

export function getOneById({ id, onSuccess, onError }) {
    _getOneById({
        url: `${BASE_URL}/${id}`,
        onSuccess,
        onError,
        normalizer: normalizeRequestData,
    });
}

export function deleteAll({ ids, onSuccess, onError }) {
    _deleteAll({ url: BASE_URL, data: { ids }, onSuccess, onError });
}

export function setStatusAsync(id, status) {
    return _patchAsync({ url: `${BASE_URL}/${id}:change-status`, data: status });
}
